[
    { "title": "Ristretto", "price": "50,- Kč" },
    { "title": "Espresso", "price": "55,- Kč" },
    { "title": "Macchiato", "price": "55,- Kč" },
    { "title": "Americano", "price": "60,- Kč" },
    { "title": "Doppio", "price": "60,- Kč" },
    { "title": "Flat white", "price": "80,- Kč" },
    { "title": "Turecká káva Mehmet Effendi", "price": "50,- Kč" },
    { "title": "Cappuccino", "price": "65,- Kč" },
    { "title": "Mandlové cappuccino", "price": "85,- Kč" },
    { "title": "Café Latte", "price": "75,- Kč" },
    { "title": "Espresso tonik", "price": "95,- Kč" },
    { "title": "Ledová káva", "price": "85,- Kč" },
    { "title": "Matcha cappuccino", "price": "75,- Kč" },
    { "title": "Čokoláda", "price": "60,- Kč" },
    { "title": "Čaj černý, ovocný", "price": "40,- Kč" }
]